import * as React from 'react';

interface CollectionGridContextValue {
  /**
   * The ID of the portfolio to fetch collections for
   */
  portfolioId?: string;
  /**
   * The ID of the organization
   */
  organizationId?: string;
  /**
   * Number of items to fetch per page
   */
  limit: number;
}

const CollectionGridContext = React.createContext<CollectionGridContextValue | undefined>(undefined);

export { CollectionGridContext };
export type { CollectionGridContextValue };
